import React from "react";
import { styled } from "@mui/material/styles";
import { Dialog, DialogContent, IconButton } from "@mui/material";
import { Typography } from "@mui/material";
import applogo from "../assets/logo.svg";
import close_icon from '../../User/assets/icons/close-icon.svg'

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));
const LivePopup = ({ handleLivePopupCloseModal, isLivePopup }) => {
  return (
    <>
      <BootstrapDialog
        onClose={handleLivePopupCloseModal}
        aria-labelledby="customized-dialog-title"
        open={isLivePopup}
        className="live-soon-popup"
      >

        <IconButton
          aria-label="close"
          onClick={handleLivePopupCloseModal}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <img src={close_icon} alt="close_icon" />
        </IconButton>
        <DialogContent dividers>
          <section className="live-soon">
            <div className="live-soon-content">
              <div className="live-soon-image">
                <img src={applogo} alt="applogo" />
              </div>
              <div className="live-soon-text">
                <Typography variant="h4">
                  WE WILL BE <span>LIVE SOON</span>
                </Typography>
                <Typography variant="h5">
                  Our Tailors4U team offers custom designs, consultations, and lets
                  you upload your own designs.
                </Typography>
              </div>
            </div>
          </section>
        </DialogContent>
      </BootstrapDialog>
    </>
  );
};

export default LivePopup;
